// Half-size (degrees) of the rectangle built around the municipality center when
// the municipality has no usable bounds (COEGIS1-15259), per axis. 0.25 covers a
// city plus its surrounding towns (~28 km N-S). Tenants can override this module
// at apps/<tenant>/src/js/lib/planner/geocoder-fallback-area.js.
export const GEOCODER_FALLBACK_HALF_SIZE_LAT_DEGREES = 0.25
export const GEOCODER_FALLBACK_HALF_SIZE_LNG_DEGREES = 0.25

// Optional tenant anchor ({lat, lng}) for the geocoder proximity bias. When set (and
// inside the search area) it replaces the municipality center as the point results
// are ranked around; the search area itself is not affected. null = not used.
export const GEOCODER_BIAS_POINT = null
